import { render, staticRenderFns } from "./overtime-detail.vue?vue&type=template&id=b2281f6c&scoped=true"
import script from "./overtime-detail.vue?vue&type=script&lang=js"
export * from "./overtime-detail.vue?vue&type=script&lang=js"
import style0 from "./overtime-detail.vue?vue&type=style&index=0&id=b2281f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2281f6c",
  null
  
)

export default component.exports